export default __webpack_public_path__ + "static/media/hhs-qld-central-queensland.7057478d.svg";